import type { SiteData } from '@/data/types';
import { resolveImagePath } from '@/utils/imageResolver';

interface FooterProps {
  siteData: SiteData;
}

export function Footer({ siteData }: FooterProps) {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { text: 'Home', href: '/' },
    { text: 'About Us', href: '/about' },
    { text: 'Our Services', href: '/services' },
    { text: 'Our Gallery', href: '/gallery' },
    { text: 'Contact us', href: '/contact' },
  ];


  return (
    <footer className="bg-[#02252a] text-white">
      {/* Main footer content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Us - Left */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-white">CONTACT US</h2>
            <div className="space-y-3">
              <img
                src={resolveImagePath(siteData.logo)}
                alt={siteData.title}
                className="h-16 w-auto object-contain"
              />
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-white">QUICK LINKS</h2>
            <nav>
              <ul className="space-y-2">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      className="text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Contact Us - Right */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-white">CONTACT US</h2>
            <div className="text-gray-300 space-y-2">
              <p>Captain Elvis Ferguson</p>
              <p>P.O. Box EX-29128</p>
              <p>George Town, Great Exuma</p>
              <p>Bahamas</p>
              <p className="pt-2">
                <a
                  href={`tel:${siteData.phone}`}
                  className="text-white hover:text-blue-300 transition-colors duration-200"
                >
                  {siteData.phone}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom copyright section */}
      <div className="bg-[#022431] border-t border-gray-600">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
            <p>
              © Copyright {currentYear} by {siteData.title}. All rights reserved.
            </p>
            <p>
              Website by{' '}
              <a
                href="https://siteforward.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 transition-colors duration-200"
              >
                SiteForward
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}